import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { createI18n } from 'vue-i18n';
import App from './App.vue';
import { createGtag } from "vue-gtag";
import ElementPlus from 'element-plus';
import './index.css';
import 'element-plus/dist/index.css';
import 'vuetify/styles';
// https://stackoverflow.com/questions/57053728/vuetify-icon-not-showing
import '@mdi/font/css/materialdesignicons.css'
import '@/style/apos.css';
import '@/style/global.css';
import 'mapbox-gl/dist/mapbox-gl.css';
import 'v-calendar/style.css';
import "vue3-histogram-slider/dist/histogram-slider.css";
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import VueApexCharts from 'vue3-apexcharts';
import VCalendar from 'v-calendar';
import Vue3TouchEvents from 'vue3-touch-events';
import HistogramSlider from "vue3-histogram-slider";
import { VueResponsiveness } from 'vue-responsiveness'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import * as Sentry from "@sentry/vue";
import router from './router/router';

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  Filler
} from 'chart.js'

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    BarElement,
    Title,
    Tooltip,
    Legend,
    Filler
)

import enUS from './locales/en.json';
import elGR from './locales/el.json';
import deDE from './locales/de.json';
import frFR from './locales/fr.json';
import LocationMap from "@/components/Map/LocationMap.vue";

// Create Pinia instance
const pinia = createPinia();

// Create Vuetify instance
const vuetify = createVuetify({
  components,
  directives,
});




// Create i18n instance
const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: 'en', // default locale
  fallbackLocale: 'en',
  messages: {
    'en': enUS,
    'el': elGR,
    'de': deDE,
    'fr': frFR
  },
  numberFormats: {
    'en': {
      euro: {
        style: 'currency',
        currency: 'EUR',
        currencyDisplay: 'symbol',
        useGrouping: true,
        notation: 'standard',
      },
      pound: {
        style: 'currency',
        currency: 'GBP',
        currencyDisplay: 'symbol',
        useGrouping: true,
        notation: 'standard',
      },
    },
    'de': {
      euro: {
        style: 'currency',
        currency: 'EUR',
        currencyDisplay: 'symbol',
        useGrouping: true,
        notation: 'standard',
      },
      pound: {
        style: 'currency',
        currency: 'GBP',
        currencyDisplay: 'symbol',
        useGrouping: true,
        notation: 'standard',
      },
    },
    'fr': {
      euro: {
        style: 'currency',
        currency: 'EUR',
        currencyDisplay: 'symbol',
        useGrouping: true,
        notation: 'standard',
      },
      pound: {
        style: 'currency',
        currency: 'GBP',
        currencyDisplay: 'symbol',
        useGrouping: true,
        notation: 'standard',
      },
    },
    'el': {
      euro: {
        style: 'currency',
        currency: 'EUR',
        currencyDisplay: 'symbol',
        useGrouping: true,
        notation: 'standard',
      },
      pound: {
        style: 'currency',
        currency: 'GBP',
        currencyDisplay: 'symbol',
        useGrouping: true,
        notation: 'standard',
      },
    },

  },
});

const gtag = createGtag({
  tagId: "GTM-PVG32PR9"
})

// Register Vue App
const app = createApp(App)
  .use(router)
  .use(VueResponsiveness, {
      'sm': 768,
      'md': 1024,
      'lg': 1440,
      'xl': 1920,
    })
  .use(ElementPlus)
  .use(vuetify)
  .use(pinia)
  .use(VueApexCharts)
  .use(gtag)
  .use(i18n)
  .use(Vue3TouchEvents)
  .use(VCalendar)
  .use(VueReCaptcha,{siteKey:  import.meta.env.VITE_RECAPTCHA_KEY})
  .component("MapPopup", LocationMap)
  .component(HistogramSlider.name, HistogramSlider);


Sentry.init({
  app,
  dsn: import.meta.env.VITE_SENTRY_DSN,
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  integrations: [
    Sentry.replayIntegration({
      maskAllText: false,
    })
  ],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

router.isReady().then(() => {
  app.mount('#app');
});
